import { commonTypes } from '../common';

export const initialState = {
  ppipInfo: {
    clientPhoneNumberToBeAppliedTo: null,
    id: null,
    ppipRequired: false,
  },
};

const ApisNeedsPpipReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_PPIP_SELECTED: {
      const { ppipSelected } = action.payload;
      return {
        ...state,
        ppipInfo: {
          ...state.ppipInfo,
          ppipRequired: ppipSelected,
        },
      };
    }
    case commonTypes.SET_PPIP_AS_AVAILABLE: {
      const {
        clientPhoneNumberToBeAppliedTo,
        id,
      } = action.payload;
      return {
        ...state,
        ppipInfo: {
          ...state.ppipInfo,
          clientPhoneNumberToBeAppliedTo,
          id,
        },
      };
    }
    default:
      return null;
  }
};

export const actions = {

};

export default ApisNeedsPpipReducer;
